import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useShop(shopId: string) {
  const { data, status } = useQuery({
    ...queries.shop.detail(shopId),
    enabled: !!shopId,
  });
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('매장 정보를 불러오는데 실패했습니다.');
    }
  }, [status]);
  return data;
}

export default useShop;
